import React from "react";

interface ColorPillAttribs {
    color: string;
    width: number;
    style?: any;
}

const ColorPill = ({color, width, style}: ColorPillAttribs) => (
    <div style={{...style, backgroundColor: color, width: `${width}px`, height: `${width/2}px`, borderRadius: `${width/4}px`, display: "inline-block"}} />
);

export default ColorPill;